import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  ModalTrigger,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from 'modules/theme';

import { FormWrapper, FormColumn } from 'modules/theme';
import { ModalFooter } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { Alert } from 'modules/theme';
// import DownloadFile from './DownloadFile';
// import AddTemplates from '../../../../common/components/AddTemplates';

const contextTypes = {
  __: PropTypes.func
};

class importFile extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.importFile = this.importFile.bind(this);
    this.mAPI = new APIManager();
    this.state = {
      showHide: false,
      file: null
    };
  }

  componentWillUnmount() {
    // this.props.clearState();
  }

  closeModal(isUpdated) {
    console.log('closeModal');
    if (isUpdated && this.props.importDone) {
      this.props.importDone();
    }
    this.setState({ showHide: false });
  }
  openModal() {
    console.log('openModal');
    this.setState({ showHide: true });
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }
  apiResponse(errorCode, data) {
    console.log('Error Code', errorCode);
    if (errorCode === 0 || errorCode === 200) {
      let message = 'File Successfully Updated.';
      data && data.message ? data.message : 'Successfully updated';
      Alert.success(`${message}`);
      this.closeModal();
    } else {
      let message = data && data.message ? data.message : 'Upload Sound Error';
      Alert.error(`${message}`);
    }
  }
  importFile(e) {
    let _this = this;
    const { title = "", apiUrl = '', fetchData, setFilename } = this.props;
    let formData = fetchData(this.state.file);

    let extRegex = /^.*\.(png|PNG|jpg|JPG|jpeg|JPEG|mp4|MP4|webp|WEBP|gif|GIF|mpeg|MPEG|MPEG4|mpeg4)$/;

    if((title === "Upload Media" || title === "Upload Thumbnail") && this.state.file.size > 5097152) {
      return Alert.error("File size cannot be max than 5 MB");
    }

    if ((title === "Upload Media" || title === "Upload Thumbnail") && !extRegex.test(this.state.file.name)) {
      return Alert.error("You can only upload png, jpg, jpeg, gif, mp4, mpeg, mpeg4 and webp.");
    }

    if (this.state.file) {
      // console.log("fileeeee", this.state.file.name,this.state.file);
      if(title === "Bulk RCS") {
        setFilename(this.state.file);
        Alert.success(`Success`);
        this.closeModal();
      } else if(title === "Upload Media" || title === "Upload Thumbnail") {
        this.mAPI.sendPostForm(
          `${apiUrl}`,
          formData,
          data => {
            //Set the progress value to show the progress bar
            console.log('Upload progress', data);
            // console.log(JSON.stringify(data, null, 2));
            // if(title === "Upload Multiple Format" || title === "Upload Personalize Format") {
              setFilename(data, title);
              Alert.success(`Success`);
              
            // }else if(title === "Bulk Template") {
            //   Alert.success(data.message || "File Uploaded!!");
            //   this.props.retrieveAllTemplate();
  
            // }else {
            //   Alert.success(data.message || "File Uploaded!!");
            // }
            this.closeModal(true);
          },
          (errorCode, data) => {
            // this.apiResponse(errorCode, data);
            if(errorCode === 403){
              Alert.error("Please upload in correct format!")
            } else {
              Alert.error("Something went wrong!")
            }
            console.log(data);
          },
          {},
          null,
          "POST",
          "direct"
        );
      }
      
      
    } else {
      Alert.error('Enter File...');
    }
  }
  render() {
    const { __ } = this.context;
    const {
      buttonTitle = 'Import',
      title = 'Import',
      modalType = 'mid',
      fileAccept = '.csv',
      urlDownload = '',
      btnStyle="default",
      icon="upload-6",
      iconSize="inherit",
      style=null
    } = this.props;
    const importTrigger = (
      <Button
        btnStyle={btnStyle}
        size="medium"
        icon={icon}
        iconSize={iconSize}
        style={ style ? style :{ marginLeft: '5px', width: 'auto',marginBottom:"5px" }}
      >
        {/* <BsBoxArrowInDown /> */}
        {buttonTitle}
      </Button>
    );

  //   const bulkColumns = [{
  //     id: 'first',
  //     displayName: 'Mobile no:'
  //   }];
  
  //   const bulkDatas = [{
  //     first: "+919999999999",
  //   },
  //   {
  //     first: "+919999999999",
  //   },
  //   {
  //     first: "+919999999999",
  //   },
  //   {
  //     first: "+919999999999",
  //   }
  // ];

  //   const personalizeColumns = [{
  //     id: 'first',
  //     displayName: 'mobNo'
  //   }, {
  //     id: 'second',
  //     displayName: 'C1'
  //   }, {
  //       id: 'third',
  //       displayName: 'C3'
  //   }]
  
  //   const personalizeDatas = [{
  //     first: "",
  //     second: "",
  //     third: ""
  //   }];

  //   const multipleSmsColumns = [{
  //     id: 'first',
  //     displayName: 'Sender'
  //   }];
  
  //   const multipleSmsDatas = [{
  //     first: ""
  //   }];

    return (
      <ModalTrigger
        title={title}
        trigger={importTrigger}
        size={modalType}
        showHide={this.state.showHide}
        closeModal={this.closeModal}
        openModal={this.openModal}
        dialogClassName={modalType}
      >
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('File', {
              // defaultValue: '',
              autoFocus: true,
              componentClass: 'file',
              required: true,
              type: 'file',
              value: '',
              accept: fileAccept,
              selectedFile: this.state.file,
              onChange: e => {
                if (e.target.files && e.target.files[0]) {
                  this.setState({ file: e.target.files[0] });
                } else {
                  this.setState({ file: null });
                }
              },
              id: 'file'
            })}
          </FormColumn>
        </FormWrapper>
        <ModalFooter>
          <div style={{ textAlign: 'left', marginBottom: '5px' }}>
            {title === "Bulk Template" && 
            <div></div>
            // <DownloadFile data={bulkDatas} columns={bulkColumns} fileName="Sample-file"/>
            }
            {/* {title === "Upload Multiple Format" && <AddTemplates title="Example Format Preview"/>} */}
            {title === "Upload Personalize Format" && 
            <div></div>
            // <DownloadFile data={personalizeDatas} columns={personalizeColumns} fileName="Personalize-SMS-Template"/>
            }
            {title === "Bulk RCS" &&
            <Button
              btnStyle="link"
              size="medium"
              icon="folder-download"
              target="_blank"
              href={this.mAPI.downloadUrl(`${urlDownload}`)}
            >
              {'Download Sample File'}
            </Button>}
            
          </div>
          <Button
            btnStyle="cancel"
            onClick={() => this.closeModal()}
            // icon="cancel-1"
            size="xl"
            style={{ marginRight: '10px' }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
            onClick={() => this.importFile()}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalTrigger>
    );
  }
}

importFile.contextTypes = contextTypes;

export default importFile;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/ImportFile.js